import { render, staticRenderFns } from "./SettingsDropdown.vue?vue&type=template&id=64b9d0da"
import script from "./SettingsDropdown.vue?vue&type=script&lang=js"
export * from "./SettingsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports